const LaudoRoutes = [
  {
    path: "/laudos",
    name: "LaudoIndex",
    component: () => import("@/_laudos/pages/LaudoPage.vue"),
    // component: () => import("@/_extra_info/pages/Laudos.vue"),
    meta: {
      translated: "Laudos",
      auth: true,
      permission: { act: "read", on: "Form" },
    },
    // children: [
    //   {
    //     path: "kanban",
    //     name: "LaudoKanban",
    //     component: () => import("@/_extra_info/pages/LaudoKanban.vue"),
    //     // component: () => import("@/_extra_info/pages/Laudos.vue"),
    //     meta: {
    //       translated: "Informações Extra",
    //       auth: true,
    //       permission: { act: "read", on: "Form" },
    //     },
    //   },
    // ]
  },
];

export default LaudoRoutes;
